import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Typography,
  Card,
  Spin,
  Button,
  Form,
  Row,
  Col,
  Flex,
  Steps,
} from "antd";

//PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import styles from "../../../assets/styles/styles";
import TillAuthorizationForm from "./components/TillAuthForm";
import BranchLimitForm from "./components/BranchLimitsForm";
import Preview from "./components/Preview";
import { labelConfig, staticConfig, apiConfig } from "../systemAdmin.config";

const AddSYA0600 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { Text, Title } = Typography;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [current, setCurrent] = useState(0);
  const [configureLimitTableSource, setConfigurelimitTableSource] = useState(
    []
  );
  const [configureTransactionTableSource, setConfigureTransactionTableSource] =
    useState([]);
  const [officeData, setOfficeData] = useState([]);
  const [codeValueData, setCodeValueData] = useState([]);
  const [transactionCurrencyData, setTransactionCurrencyData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [] = useState([]);
  const [templateConfigDetail, setTemplateConfigDetail] = useState({});
  const [LimitCount, setLimitCount] = useState(0);
  const [transactionCount, setTransactionCount] = useState(0);
  const [branchConfigList, setBranchConfigList] = useState([]);
  const [
    selectedbranchConfigValueCurrencyCode,
    setSelectedbranchConfigValueCurrencyCode,
  ] = useState(0);
  const [officeName, setOfficeName] = useState([]);
  const [selectedbranchConfigValue, setSelectedbranchConfigValue] = useState(0);
  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    authForm: null,
    branchCcyRestrConfs: null,
    branchOperationTransactionType: null,
  });

  useEffect(() => {
    // getOffices();
    // getCurrencies();
    // getValutValues();
    // getTellerTransactionType();
    getVaultConfigList();
  }, []);

  useEffect(() => {
    if (selectedbranchConfigValue > 0) {
      getVaultCurrencyrestrById();
    }
  }, [selectedbranchConfigValue]);

  const onFinishAuthForm = (values) => {
    // console.log(values);

    setFormData({ ...formData, authForm: values });
    setCurrent(current + 1);
  };

  const onFinishLimitsForm = (values) => {
    // console.log(values);
    // console.log(configureLimitTableSource);

    const tempNewCurrencyData = configureLimitTableSource.map((configItem) => {
      const matchedCurrency = currencyData?.find(
        (currencyItem) => currencyItem.value === configItem.currencyCode
      );

      return {
        value: configItem.currencyCode,
        label: matchedCurrency?.label || configItem.currencyCode,
      };
    });

    // console.log(tempNewCurrencyData);
    setTransactionCurrencyData(tempNewCurrencyData);

    let tempConfigData = [];

    configureLimitTableSource.forEach((element, index) => {
      tempConfigData.push({
        authThresholdAmount: element.authThresholdAmount,
        currencyCode: element.currencyCode,
        transactionLimit: element.transactionLimit,
        locale: "en",
        branchOperationTransactionTypes: [],
      });
    });

    setFormData({
      ...formData,
      branchCcyRestrConfs: configureLimitTableSource,
    });
    setCurrent(current + 1);
  };

  const onFinishTransactionForm = (values) => {
    console.log(values);
    console.log(configureTransactionTableSource);

    let tempConfigData = [];

    configureTransactionTableSource.forEach((element, index) => {
      tempConfigData.push({
        transactionType: element.authThresholdAmount,
        currencyCode: element.currencyCode,
        transactionTypeLimit: element.transactionLimit,
        locale: "en",
      });
    });

    setFormData({
      ...formData,
      branchOperationTransactionType: configureTransactionTableSource,
    });
    setCurrent(current + 1);
  };

const selectedOfficeName = branchConfigList.find(
  (item) => item.value === selectedbranchConfigValue
)?.label || null;

console.log(selectedOfficeName)
  const forms = [
    <TillAuthorizationForm
      onFinish={onFinishAuthForm}
      form={useForm}
      formData={formData.authForm}
      officeData={officeData}
      setSelectedbranchConfigValue={setSelectedbranchConfigValue}
      branchConfigList={branchConfigList}
    />,
    <BranchLimitForm
      onFinish={onFinishLimitsForm}
      form={useForm}
      formData={formData.branchCcyRestrConfs}
      userData={userData}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      configureLimitTableSource={configureLimitTableSource}
      setConfigurelimitTableSource={setConfigurelimitTableSource}
      LimitCount={LimitCount}
      setLimitCount={setLimitCount}
      currencyData={currencyData}
      selectedbranchConfigValueCurrencyCode={
        selectedbranchConfigValueCurrencyCode
      }
    />,

    <Preview
      formData={formData}
      currencyData={currencyData}
      officeData={officeData}
      configureLimitTableSource={configureLimitTableSource}
      configureTransactionTableSource={configureTransactionTableSource}
      selectedOfficeName={selectedOfficeName}
    />,
  ];

  const isLastStep = current === forms.length - 1;

  const nextButtonClick = () => {
    useForm.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  const getOffices = () => {
    setIsLoading(true);

    const url = apiConfig.Offices;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setTemplateConfigDetail(res);
        const objDetails = res;
        let tempOfficeData = [];

        objDetails?.forEach((element) => {
          tempOfficeData.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(tempOfficeData);

        setIsLoading(false);
      }
    });
  };

  const getVaultConfigList = () => {
    let body = { session };

    BOM.FetchReqAction(body, apiConfig.VaultConfig, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        console.log(res);
        const dropdownOptions = res.map((element) => ({
          value: element.id,
          label: element.operationId2.officeId.name,
        }));

        setOfficeName(res[selectedbranchConfigValue].operationId2);
        setBranchConfigList(dropdownOptions);
        setIsLoading(false);
      }
    });
  };

  console.log(officeName);
  // console.log(selectedbranchConfigValue);
  const getVaultCurrencyrestrById = () => {
    let body = { session };
    // selectedbranchConfigValue
    let url = `${
      apiConfig.VaultConfig +
      `/vaultcurrencyrestr` +
      `/${selectedbranchConfigValue}`
    }`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        console.log(res);

        const currencyOptions = res.map((item) => ({
          value: item.currencyCode,
          label: item.currencyCode,
        }));

        setSelectedbranchConfigValueCurrencyCode(currencyOptions);
      }
    });
  };

  const getValutValues = () => {
    const url = apiConfig.VaultConfig;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        console.log(res);
        const objDetails = res;
        let tempValutData;
      }
    });
  };

  const getCurrencies = () => {
    setIsLoading(true);

    const url = apiConfig.Currencies;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetails = res;
        let tempCurrencyData = [];

        objDetails?.selectedCurrencyOptions?.forEach((element) => {
          tempCurrencyData.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setCurrencyData(tempCurrencyData);

        setIsLoading(false);
      }
    });
  };

  const getTellerTransactionType = () => {
    setIsLoading(true);

    const url = `${apiConfig.Codes}/codevalue/TellerTransactionType`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        console.log(objList);

        getCodeValues(objList);

        setIsLoading(false);
      }
    });
  };

  const getCodeValues = (param) => {
    setIsLoading(true);

    const url = `${apiConfig.Codes}/${param.id}/ CodeValues`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetails = res;
        let tempCodeValueData = [];

        objDetails?.forEach((element) => {
          tempCodeValueData.push({
            value: element.id,
            label: element.name,
          });
        });

        setCodeValueData(tempCodeValueData);

        setIsLoading(false);
      }
    });
  };

  const onSubmit = () => {
    const formValues = {
      locale: "en",
      ...formData.authForm, // Should include vaultId, description, allowDenomTracking, etc.
      tellerCcyRestrConfs: formData.branchCcyRestrConfs.map((item) => ({
        tellerCcyRestrConf: {
          locale: "en",
          currencyCode: item.currencyCode,
          authThresholdAmount: item.authThresholdAmount.toString(),
          transactionLimit: item.transactionLimit.toString(),
        },
      })),
    };

    // const test = {"locale":"en","vaultId":13,"description":"tillars","allowDenomTracking":true,"printTransactionReceipt":true,"allowTransactionReversal":true,"tellerCcyRestrConfs":[{"tellerCcyRestrConf":{"locale":"en","currencyCode":"NGN","authThresholdAmount":"100000000","transactionLimit":"1000"}}]}

    const body = {
      locale: "en",
      ...formValues,
      method: "POST",
      session,
    };

    console.log(body);

    setIsLoading(true);

    BOM.FetchReqAction(body, apiConfig.Tellerconfig, (err, res) => {
      if (err) {
        console.log(err);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        // AlertMsg("error",err?.errors[0]?.defaultUserMessage)
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Till configuration created successfully.");
        // AlertMsg("success",labelConfig.newCasaCreatedMsg)

        navigate("/SYA0600");
        //STOP LOAD
        setIsLoading(false);
      }
    });

    setIsLoading(false);
  };

  function onCancel() {
    navigate("/SYA0600", { replace: false });
  }

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.newTillConfiguration}
        pageItems={staticConfig.newTillConfigurationBreadcrumbItems}
      />
      <Spin spinning={isLoading} tip="Loading..." size="large">
        <Card title={"Till Config..."} style={styles.cardWrapper}>
          <div>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
              style={{ marginBottom: 25 }}
            >
              <Col span={24}>
                <Row style={{ justifyContent: "space-between" }}>
                  <Card style={styles.cardSteps}>
                    <Steps
                      current={current}
                      onChange={setCurrent}
                      direction="vertical"
                      style={{ height: "600px" }}
                      items={[
                        {
                          title: <Text strong>Till Authorization</Text>,
                        },
                        {
                          title: <Text strong>Branch Limits</Text>,
                        },
                        {
                          title: <Text strong>Preview</Text>,
                        },
                      ]}
                    />
                  </Card>
                  {/* Form Section */}
                  <Card style={styles.cardStepDisplay}>
                    <div>{forms[current]}</div>
                    {/* </Form> */}
                  </Card>
                </Row>
              </Col>
            </Row>

            {/* Submitt section */}
            <Card
              style={{
                marginBottom: 25,
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
                padding: 5,
              }}
            >
              <Flex
                justify="space-between"
                style={{ paddingLeft: "20px", paddingRight: "40px" }}
              >
                {current === 0 && (
                  <Button
                    style={{
                      width: "12%",
                      height: "15%",
                      backgroundColor: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                      color: "black",
                    }}
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#15CCAE",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={prevButtonClick}
                  >
                    {labelConfig.previous}
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#15CCAE",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={nextButtonClick}
                  >
                    {labelConfig.next}
                  </Button>
                )}
                {BOM.HasPermission("CREATE_SAVINGSPRODUCT") && isLastStep && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    onClick={onSubmit}
                    backgroundColor="#fff"
                    colorText="black"
                    hoverBackground="#F5F5F5"
                  />
                )}
              </Flex>
            </Card>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddSYA0600);
